import { useMutation, useQueryClient } from '@tanstack/react-query';
import { massRestoreProjects } from '../../api/apiProjects';
import toast from 'react-hot-toast';

export const useMassRestoreProjects = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: massRestoreProjects,
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ['projects'] });
            toast.success(data.message || 'Projects restored successfully');
        },
        onError: (error) => {
            const errorMessage = error.response?.data?.message || 'Failed to restore projects';
            toast.error(errorMessage);
        },
    });
};